import { useEffect, useState } from 'react';

import { navigate, routes } from '@redwoodjs/router';
import { MetaTags, useQuery } from '@redwoodjs/web';

import AccessDenied from 'src/components/AccessDenied/AccessDenied';
import Loader from 'src/components/Loader/Loader';
import { NPIDataGrid } from 'src/components/NPIDataGrid/NPIDataGrid';
import { ROLE_PERMISSIONS } from 'src/constants/role-permissions';
import { GET_NEARING_EXPIRY_SERVICES } from 'src/graphql/queries/services.query';
import useHasPermission from 'src/hooks/useHasPermission';
import { PageContent } from 'src/layouts/MainLayout/PageContent';
import { onError } from 'src/utils/utils';

import ExpiringServicesGridColDef from './ExpiringServicesGridColDef';

const ExpiringServicesPage = () => {
    const [tableData, setTableData] = useState({
        rows: [],
    });

    const hasPermission = useHasPermission(ROLE_PERMISSIONS.customerSuccess);

    const handleView = ({ id }: { id: string }) => {
        const baseUrl = routes.viewService({ id, from: 'customer-success' });
        navigate(baseUrl);
    };

    const { data, loading } = useQuery(GET_NEARING_EXPIRY_SERVICES, {
        fetchPolicy: 'network-only',
        onError,
    });

    useEffect(() => {
        const expiredServices = data?.retrieveNearingExpiryServices;

        if (expiredServices) {
            setTableData({
                rows: expiredServices,
            });
        } else {
            setTableData({
                rows: [],
            });
        }
    }, [data]);

    if (loading || !data) return <Loader />;

    if (!hasPermission) {
        return <AccessDenied permission={ROLE_PERMISSIONS.customerSuccess} />;
    }

    return (
        <PageContent
            heading="Expiring Services"
            subHeading="View and manage all services that are due to expiry"
        >
            <MetaTags title="Expiring Services" description="Expiring Services page" />
            <NPIDataGrid
                rows={tableData.rows}
                columns={ExpiringServicesGridColDef()}
                getRowId={(row) => {
                    return row.id;
                }}
                handleView={({ id }) => {
                    handleView({ id });
                }}
                title="Expiring Services Page"
                dataTestId="expiring-services-page-table"
            />
        </PageContent>
    );
};

export default ExpiringServicesPage;
